import {
  InformationColors,
  AbsolutesBlackColors,
  ControlTextColors,
} from '@picsart/design-system/foundation/colors';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

type propsType = {
  isMobile?: boolean;
  isColor?: boolean;
};
const useStyles = createUseStyles<string, propsType>(
  () => ({
    container: {
      width: '100%',
      padding: [Spacings.s8, Spacings.s0],
    },
    dark: {
      backgroundColor: ({ isColor }) => (isColor ? 'none' : AbsolutesBlackColors.base.default),
    },
    wrapper: {
      padding: Spacings.s0,
      '@media screen and (max-width: 1200px)': {
        padding: [Spacings.s0, Spacings.s12],
      },
    },
    darkBreadcrumb: {
      '& > li a': {
        color: 'rgb(179, 179, 179)', // has been darkValues (wrong colors was used).
      },
      '& > li a:hover': {
        color: ControlTextColors.action,
      },
      '& > li:last-child a': {
        color: 'rgb(189, 153, 248)', // has been darkValues (wrong colors was used).
      },
      '& > li:last-child a:hover': {
        color: InformationColors.base.action,
      },
    },
    breadcrumbsRoot: {
      '& > li:last-child a': {
        pointerEvents: 'none',
      },
    },
  }),
  {
    name: 'Breadcrumbs',
  },
);

export default useStyles;
